/**
 * 与后端枚举对齐，参见后端 com.yxbs.forum.common.enums.*
 */

export const TopicType = {
  QUESTION: 1,
  ARTICLE: 2,
} as const

export type TopicTypeCode = (typeof TopicType)[keyof typeof TopicType]

export const TopicTypeLabel: Record<TopicTypeCode, string> = {
  [TopicType.QUESTION]: '问题',
  [TopicType.ARTICLE]: '文章',
}

export const TopicTypeColor: Record<TopicTypeCode, string> = {
  [TopicType.QUESTION]: '#3b82f6',
  [TopicType.ARTICLE]: '#22c55e',
}

export const AuditStatus = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
} as const

export const AuditStatusLabel: Record<number, string> = {
  0: '审核中',
  1: '已发布',
  2: '已驳回',
}

export const PointRuleCode = {
  REGISTER_AWARD: 'REGISTER_AWARD',
  PUBLISH_QUESTION: 'PUBLISH_QUESTION',
  PUBLISH_ARTICLE: 'PUBLISH_ARTICLE',
} as const

/**
 * 后端 ResultCode 业务错误码（与 forum-common ResultCode 对齐）
 */
export const ResultCode = {
  OK: 0,
  USERNAME_INVALID: 1001,
  NICKNAME_INVALID: 1002,
  PASSWORD_INVALID: 1003,
  USERNAME_TAKEN: 1004,
  LOGIN_FAILED: 1005,
  ACCOUNT_DISABLED: 1006,
  AUTH_EXPIRED: 1007,
  TOPIC_TYPE_INVALID: 2001,
  CATEGORY_INVALID: 2002,
  TITLE_INVALID: 2003,
  CONTENT_INVALID: 2004,
  TOPIC_NOT_FOUND: 2005,
  NO_PERMISSION: 2006,
  PARAM_ERROR: 9000,
  SYSTEM_ERROR: 9999,
} as const
